var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "profile-list" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-cogs" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("news.title")))]),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.newsItems === undefined
          ? _c(
              "div",
              { staticClass: "news-container-list" },
              [
                _c("lottie-player", {
                  staticStyle: { width: "300px", height: "300px" },
                  attrs: {
                    src: "/static/animations/newspaper.json",
                    mode: "bounce",
                    foreground: "#666666",
                    background: "#FFFFFF",
                    speed: "1",
                    loop: "",
                    autoplay: "",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.newsItems !== undefined &&
        Array.isArray(_vm.newsItems) &&
        _vm.newsItems.length === 0
          ? _c("div", { staticClass: "news-container-list" }, [
              _c("p", { staticClass: "empty-set" }, [
                _vm._v(_vm._s(_vm.$t("news.nonews"))),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.newsItems !== undefined &&
        Array.isArray(_vm.newsItems) &&
        _vm.newsItems.length > 0
          ? _c(
              "div",
              { staticClass: "news-container-list" },
              _vm._l(_vm.newsItems, function (item) {
                return _c(
                  "UiCard",
                  { key: item.id, staticClass: "news-item mb-4" },
                  [
                    _c("article", [
                      _c("header", { staticClass: "news-item-header mb-4" }, [
                        _c("h4", { staticClass: "text-2xl mb-3" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.title.replace("Edition", "Édition")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-sm" }, [
                          item.type
                            ? _c(
                                "span",
                                {
                                  staticClass: "news-item-type mr-2",
                                  class: [
                                    item.type === "beta" ? "beta" : "",
                                    item.type === "new" ? "new" : "",
                                    item.type === "astuce" ? "astuce" : "",
                                    item.type === "info" ? "info" : "",
                                  ],
                                },
                                [_vm._v(_vm._s(item.type))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-gray-400 font-medium uppercase",
                            },
                            [_vm._v(_vm._s(_vm.getDisplayDate(item)))]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "news-item-content prose",
                        domProps: {
                          innerHTML: _vm._s(
                            item.content.replace("Edition", "Édition")
                          ),
                        },
                      }),
                    ]),
                  ]
                )
              }),
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }